import AppConfigs from 'general/constants/AppConfigs'
import PreferenceKeys from 'general/constants/PreferenceKeys'
import store from 'app/store'

const getCompanyKey = () => {
  try {
    const state = store?.getState?.()
    const company = state?.auth?.currentCompany || state?.system?.company
    return (
      company?.taxCode ||
      company?.companyTaxCode ||
      company?.companyId ||
      company?.id ||
      localStorage.getItem(PreferenceKeys.savedLoginTaxCode) ||
      'common'
    )
  } catch (e) {
    return 'common'
  }
}

const getStorageKey = () => {
  const companyKey = getCompanyKey()
  return `${AppConfigs.packageName}_dismissed_warning_invoices_${companyKey}`
}

const DISMISSED_EXPIRY_DAYS = 7
const DISMISSED_EXPIRY_MS = DISMISSED_EXPIRY_DAYS * 24 * 60 * 60 * 1000

const WarningNotAcceptedHelper = {
  getDismissedIds: () => {
    try {
      const data = localStorage.getItem(getStorageKey())
      if (!data) return []
      const parsed = JSON.parse(data)
      const dismissedAt = parsed?.dismissedAt || parsed?.date
      const dismissedTime = dismissedAt ? new Date(dismissedAt).getTime() : NaN

      if (
        Number.isFinite(dismissedTime) &&
        Date.now() - dismissedTime < DISMISSED_EXPIRY_MS &&
        Array.isArray(parsed?.invoiceIds)
      ) {
        return parsed.invoiceIds.map(String)
      }

      localStorage.removeItem(getStorageKey())
      return []
    } catch (e) {
      return []
    }
  },

  addDismissed: (invoiceIds) => {
    try {
      if (!invoiceIds || !invoiceIds.length) return
      const existing = WarningNotAcceptedHelper.getDismissedIds()
      const updated = [...existing]

      // Check for duplicates before pushing invoiceId into array
      invoiceIds.forEach((id) => {
        const stringId = String(id || '')
        if (stringId && !updated.includes(stringId)) {
          updated.push(stringId)
        }
      })

      localStorage.setItem(
        getStorageKey(),
        JSON.stringify({
          dismissedAt: new Date().toISOString(),
          invoiceIds: updated,
        }),
      )
    } catch (e) {
      console.error('Error adding dismissed warning invoices:', e)
    }
  },

  removeDismissed: (invoiceIds) => {
    try {
      if (!invoiceIds || !invoiceIds.length) return
      const removeSet = new Set(invoiceIds.map(String))
      const existing = WarningNotAcceptedHelper.getDismissedIds()
      const updated = existing.filter((id) => !removeSet.has(id))
      localStorage.setItem(
        getStorageKey(),
        JSON.stringify({
          dismissedAt: new Date().toISOString(),
          invoiceIds: updated,
        }),
      )
    } catch (e) {
      console.error('Error removing dismissed warning invoices:', e)
    }
  },

  isDismissed: (invoiceId) => {
    if (!invoiceId) return false
    const existing = WarningNotAcceptedHelper.getDismissedIds()
    return existing.includes(String(invoiceId))
  },

  shouldAutoShow: (rows, invoiceIds = []) => {
    if ((!rows || !rows.length) && !invoiceIds.length) return false

    const dismissedIds = WarningNotAcceptedHelper.getDismissedIds()
    const warningIds = invoiceIds.length
      ? invoiceIds.map(String)
      : rows.map((r) => String(r?.invoiceId || r?.id || '')).filter(Boolean)

    return warningIds.some((id) => !dismissedIds.includes(id))
  },
}

export default WarningNotAcceptedHelper
